export default {
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  fullscreen: () => import("/vercel/path0/layouts/fullscreen.vue").then(m => m.default || m),
  guest: () => import("/vercel/path0/layouts/guest.vue").then(m => m.default || m)
}